module.exports = __webpack_public_path__ + "img/credit-icon-3.ea97655f.svg";